import React, { useCallback, useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkedFilterListing } from "../../Redux/Slices/ProductSlice";
import { checkFLMasterListing } from "../../Redux/Slices/FiltergetSlice";
// import { FITER_OBJECT } from "../../../../Redux/SagaAction/actions";

const FilterCM = ({ title, data, name = "name", count,className }) => {
  const dispatch = useDispatch();
  const { checkedFilter } = useSelector((e) => e.ProductSlice);
  const { checkedFilterCM } = useSelector((e) => e.FiltergetSlice);
  return (
    <>
      <div className={`filter-box ${className? className : ""}`}>
        <div className="filter-header">
          <div className="filter-title">
            {title === "discountRangeList"
              ? "Discount"
              : title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()}
          </div>
          {/* <Search
                name={title}
                data={data}
                setSearched={setSearched}
                searched={searched}
                /> */}
        </div>
        <div className="filter-list">
          <ul
            className={
              title === "color"
                ? "size-list color-list"
                : title === "size"
                ? "size-list"
                : ""
            }
          >
            {data &&
              data?.map((cc, i) => {
                return (
                  <li
                    key={cc?._id}
                    className={
                      title === "color"
                        ? checkedFilterCM?.[title]?.some((e) => {
                            return e?.uniqId === cc?._id;
                          })
                          ? "active"
                          : ""
                        : title === "size"
                        ? checkedFilterCM?.[title]?.some((e) => {
                            return e?.uniqId === cc?._id;
                          })
                          ? "active"
                          : ""
                        : ""
                    }
                    onClick={() => {
                      if (title === "size") {
                        dispatch(
                          checkFLMasterListing({
                            mainId: {
                              uniqId: cc?._id,
                              filterName: cc?.[name],
                            },
                            name: title,
                          })
                        );
                      }
                    }}
                  >
                    {title === "size" && cc?.name}
                    {title === "size" ? (
                      ""
                    ) : title === "color" ? (
                      <div
                        className="circle"
                        style={{
                          backgroundColor: cc?.name
                            ?.toLowerCase()
                            ?.replace(/-/g, ""),
                        }}
                        onClick={() => {
                          dispatch(
                            checkFLMasterListing({
                              mainId: {
                                uniqId: cc?._id,
                                filterName: cc?.[name],
                              },
                              name: title,
                            })
                          );
                        }}
                      ></div>
                    ) : (
                      <>
                        <div className="custom-checkbox gray-bg">
                          <input
                            checked={checkedFilterCM?.[title]?.some((e) => {
                              return e?.uniqId === cc?._id;
                            })}
                            type="checkbox"
                            id={cc?._id}
                            onChange={(e) => {
                              dispatch(
                                checkFLMasterListing({
                                  mainId: {
                                    uniqId: cc?._id,
                                    filterName: cc?.[name],
                                  },
                                  name: title,
                                })
                              );
                            }}
                          />
                          <label
                            htmlFor={cc?.categoryId ? cc?.categoryId : cc?._id}
                          ></label>
                        </div>
                        <div className="filter-inner-title">{cc?.[name]}</div>
                        {title !== "shippingTime" && (
                          <span>({cc?.[count]})</span>
                        )}
                      </>
                    )}
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default FilterCM;
